import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  const STORAGE_KEY = 'astitva_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    updateCountBadges(items.length);
    renderDrawer(items);
    syncButtons(items);
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  }

  function isInWishlist(id, items) {
    items = items || getWishlist();
    return items.some(function (item) { return String(item.id) === String(id); });
  }

  function addItem(product) {
    const items = getWishlist();
    if (!isInWishlist(product.id, items)) {
      items.push(product);
      saveWishlist(items);
    }
  }

  function removeItem(id) {
    const items = getWishlist().filter(function (item) { return String(item.id) !== String(id); });
    saveWishlist(items);
  }

  function toggleItem(product) {
    const items = getWishlist();
    if (isInWishlist(product.id, items)) {
      removeItem(product.id);
    } else {
      addItem(product);
    }
  }

  function updateCountBadges(count) {
  document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
    el.textContent = count;
    el.setAttribute('data-count', count);
  });

  document.querySelectorAll('[ref="wishlistBubble"], .wishlist-bubble').forEach(function (bubble) {
    bubble.classList.toggle('visually-hidden', count === 0);
    var countEl = bubble.querySelector('[data-wishlist-count]');
    if (countEl) countEl.classList.toggle('hidden', count === 0);

    if (count > 0) {
      // Same grow/fade animation the cart bubble uses.
      requestAnimationFrame(function () {
        bubble.classList.add('cart-bubble--animating');
        var textEl = bubble.querySelector('.cart-bubble__text');
        var onEnd = function () {
          bubble.classList.remove('cart-bubble--animating');
          if (textEl) textEl.removeEventListener('animationend', onEnd);
        };
        if (textEl) textEl.addEventListener('animationend', onEnd);
      });
    }
  });
}

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function renderDrawer(items) {
    items = items || getWishlist();
    const container = document.querySelector('[data-wishlist-items]');
    const emptyState = document.querySelector('[data-wishlist-empty]');
    if (!container) return;

    if (items.length === 0) {
      container.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      return;
    }

    if (emptyState) emptyState.hidden = true;

    container.innerHTML = items.map(function (item) {
      const imageHtml = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
        : '';
      const canAddToCart = !!item.variantId;
      return (
        '<div class="wishlist-item" data-wishlist-item="' + item.id + '">' +
          '<a href="' + item.url + '" class="wishlist-item__media">' + imageHtml + '</a>' +
          '<div class="wishlist-item__body">' +
            '<a href="' + item.url + '" class="wishlist-item__title">' + escapeHtml(item.title) + '</a>' +
            '<span class="wishlist-item__price">' + (item.price || '') + '</span>' +
            '<div class="wishlist-item__actions">' +
              '<button type="button" class="wishlist-item__add-cart" data-wishlist-add-cart="' + item.id + '"' +
                (canAddToCart ? '' : ' disabled title="Select options on the product page"') + '>' +
                'Add to Cart' +
              '</button>' +
              '<button type="button" class="wishlist-item__remove" data-wishlist-remove="' + item.id + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function syncButtons(items) {
    items = items || getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      const id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', isInWishlist(id, items));
    });
  }

  function addVariantToCart(variantId, button) {
  if (!variantId) return;

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding...';

  var deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: [{ merchandiseId: variantId, quantity: 1 }],
    promise: deferred.promise
  }));

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: 'cart-drawer-section',
      sections_url: window.location.pathname
    })
  })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error((err && err.description) || 'Add to cart failed');
        });
      }
      return res.json();
    })
    .then(function (addResponse) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cartJson) {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cartJson),
            detail: {
              sections: addResponse.sections,
              itemCount: cartJson.item_count,
              source: 'wishlist',
              didError: false
            }
          });
        });
    })
    .then(function () {
      button.textContent = 'Added ✓';
      setTimeout(function () {
        button.textContent = originalText;
        button.disabled = false;
      }, 1500);
      // No manual drawer toggle needed — cart-drawer-component's
      // auto-open handles this once the event above resolves.
    })
    .catch(function (err) {
      deferred.reject(err);
      button.textContent = 'Try again';
      button.disabled = false;
    });
}

  function bindEvents() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();

        const product = {
          id: btn.getAttribute('data-product-id'),
          title: btn.getAttribute('data-product-title'),
          price: btn.getAttribute('data-product-price'),
          image: btn.getAttribute('data-product-image'),
          url: btn.getAttribute('data-product-url'),
          variantId: btn.getAttribute('data-product-variant-id') || null
        };

        toggleItem(product);
        return;
      }

      const removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        e.preventDefault();
        removeItem(removeBtn.getAttribute('data-wishlist-remove'));
        return;
      }

      const addCartBtn = e.target.closest('[data-wishlist-add-cart]');
      if (addCartBtn) {
        e.preventDefault();
        if (addCartBtn.disabled) return;

        const id = addCartBtn.getAttribute('data-wishlist-add-cart');
        const items = getWishlist();
        const item = items.find(function (i) { return String(i.id) === String(id); });
        if (item && item.variantId) {
          addVariantToCart(item.variantId, addCartBtn);
        }
        return;
      }
    });

    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) {
        const updated = getWishlist();
        updateCountBadges(updated.length);
        renderDrawer(updated);
        syncButtons(updated);
      }
    });
  }

  function init() {
    const items = getWishlist();
    updateCountBadges(items.length);
    renderDrawer(items);
    syncButtons(items);
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AstitvaWishlist = {
    add: addItem,
    remove: removeItem,
    toggle: toggleItem,
    getAll: getWishlist,
    isInWishlist: isInWishlist
  };
})();